module.exports = __webpack_public_path__ + "img/5ne.65da7de4.svg";